/**
 * Erkennt, sobald der Block sticky wird und fügt eine Klasse hinzu
 */

import $ from 'jquery';

( () => {

    $(window).on( 'scroll', function() {

        let threshold = $(window).height() * 0.1;

        requestAnimationFrame( function() {

            let windowBottom = $(window).scrollTop() + $(window).height();

            $('.block__multi-button-cta.is-style-multi-button-cta-sticky').each( function() {

                $(this).removeClass("isSticky");

                let elementBottom = $(this).offset().top + $(this).outerHeight(true);
        
                $(this).toggleClass("isSticky", windowBottom - threshold - elementBottom >= 0 );        

            });

        });

    });

})()